import React from 'react'
import { Link } from '@ta-interaktiv/contentbricks'

const COLOR_SCALE = [
  [-12.0, 'rgb(9,28,61)'],
  [-10.64, 'rgb(9,41,96)'],
  [-9.31, 'rgb(10,72,145)'],
  [-7.98, 'rgb(30,102,172)'],
  [-6.65, 'rgb(58,135,192)'],
  [-5.32, 'rgb(80,150,198)'],
  [-3.99, 'rgb(109,183,208)'],
  [-2.66, 'rgb(160,215,226)'],
  [-1.33, 'rgb(214,243,255)'],
  [0.0, 'rgb(255,255,255)'],
  [1.33, 'rgb(255,220,220)'],
  [2.66, 'rgb(252,178,160)'],
  [3.99, 'rgb(252,135,103)'],
  [5.32, 'rgb(250,95,65)'],
  [6.65, 'rgb(238,53,38)'],
  [7.98, 'rgb(197,23,28)'],
  [9.31, 'rgb(156,17,20)'],
  [10.64, 'rgb(109,12,17)'],
  [12.0, 'rgb(84,0,0)']
]

export default function Footer() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        marginTop: 20,
        flexDirection: 'column',
        fontSize: '0.7rem',
        lineHeight: 1
      }}
    >
      <div>
        {COLOR_SCALE.map(([v, c], i, arr) => (
          <div style={{ display: 'inline-block' }}>
            <div
              key={v}
              style={{
                width: 12,
                height: 18,
                background: c,
                border: '1px solid #666',
                borderLeft: i === 0 ? '1px solid #666' : 'none',
                borderRight: i === arr.length - 1 ? '1px solid #666' : 'none'
              }}
            />
          </div>
        ))}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            margin: '3px 0 15px 0'
          }}
        >
          <div>{`${-12}°C`}</div>
          <div>{`${0}°C`}</div>
          <div>{`+${12}°C`}</div>
        </div>
      </div>
      <div>
        Quelle:{' '}
        <a href='https://cds.climate.copernicus.eu'>
          Copernicus Climate Data Store
        </a>
      </div>
    </div>
  )
}
